import { NgModule, ErrorHandler } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { PermissionAllDirective } from "./directives/permission-all.directive";
import { PermissionAnyDirective } from "./directives/permission-any.directive";
import { JoinArrayPipe } from "./pipes/join-array.pipe";
import { TimeAgoPipe } from "./pipes/time-ago.pipe";
import { AddressPipe } from "./pipes/address-pipe";
import { LocationPipe } from "./pipes/location-pipe";
import { TruncateStringPipe } from "./pipes/truncate-string.pipe";
import { ErrorsHandler } from "./services/errors-handler";
import { ArrayWhereKeyReturnValue } from "./pipes/array-where-key-return-value.pipe";
import { EventTrackerDirective } from "./directives/event-tracker-directive";
import { VideoCaptureComponent } from "./components/video-capture/video-capture.component";
import { NgbProgressbarModule, NgbTypeaheadModule } from "@ng-bootstrap/ng-bootstrap";
import { ThousandSuffixPipe } from "./pipes/thousand-suffix.pipe";
import { DisplayDataSectionComponent } from "./components/display-data-section/display-data-section.component";
import { LocationTypeaheadComponent } from "./components/location-typeahead/location-typeahead.component";
import { SearchSuggestsComponent } from "./components/search-suggests/search-suggests.component";

@NgModule({
  declarations: [
    JoinArrayPipe,
    TimeAgoPipe,
    PermissionAllDirective,
    PermissionAnyDirective,
    ThousandSuffixPipe,
    AddressPipe,
    LocationPipe,
    TruncateStringPipe,
    ArrayWhereKeyReturnValue,
    EventTrackerDirective,
    DisplayDataSectionComponent,
    VideoCaptureComponent,
    LocationTypeaheadComponent,
    SearchSuggestsComponent,
  ],
  imports: [CommonModule, NgbProgressbarModule, HttpClientModule, NgbTypeaheadModule, FormsModule],
  exports: [
    JoinArrayPipe,
    TimeAgoPipe,
    PermissionAllDirective,
    PermissionAnyDirective,
    ThousandSuffixPipe,
    AddressPipe,
    LocationPipe,
    TruncateStringPipe,
    ArrayWhereKeyReturnValue,
    EventTrackerDirective,
    DisplayDataSectionComponent,
    VideoCaptureComponent,
    LocationTypeaheadComponent,
    SearchSuggestsComponent,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ErrorsHandler,
    },
    LocationPipe,
  ],
})
export class CoreModule {}
